import { Loading } from 'element-ui'

let loadingCount = 0
let loading

const startLoading = target => {
  loading = Loading.service({
    target: target,
    lock: true,
    spinner: 'el-icon-loading',
  })
}

const endLoading = () => {
  loading.close()
}

export const showLoading = target => {
  if (loadingCount === 0) {
    startLoading(target)
  }
  loadingCount += 1
}

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return
  }
  loadingCount -= 1
  if (loadingCount === 0) {
    endLoading()
  }
}
